import { v4 as uuidv4 } from "uuid";
export class PMOTagSimpleModel {
    constructor() {
        this.id = uuidv4();
        this.name = "";
        this.color = "";
        this.createdOn = null;
        this.teamId = uuidv4();
    }
}
export default class PMOTagSimple extends PMOTagSimpleModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
